import React from "react"
import styles from "./styles.scss"
import posed from "react-pose"
import Reveal from "components/Reveal"

import bifirm from "images/bifirm-logo.png"
import spiderads from "images/spiderads-logo.png"
import timecut from "images/timecut-logo.png"
import tv4 from "images/tv4-logo.png"
import nti from "images/nti-logo.svg"
import avestaKommun from "images/avesta-kommun-logo.png"
import spotify from "images/spotify-logo.png"
import hemnet from "images/hemnet-logo.svg"
import netent from "images/netent-logo.png"
import krogsveen from "images/krogsveen.png"

const ClientContainer = posed.div({
  enter: { delayChildren: 300, staggerChildren: 60 },
})

const PosedClient = posed.div({
  enter: { y: 0, opacity: 1 },
  exit: { y: 100, opacity: 0 },
})

const Client = ({ logo, url, client }) => (
  <PosedClient key={url} className={styles.client}>
    <a
      href={url}
      className={styles.clientLink}
      target="_blank"
      title={`Gå till ${url}`}
    >
      <img src={logo} className={styles.logo} alt={`${client} logo`} />
    </a>
  </PosedClient>
)

class Clients extends React.Component {
  render() {
    return (
      <section className={styles.clients}>
        <h2 className={styles.clientTitle}>
          Några av <span className={styles.primaryColor}>våra kunder</span>
        </h2>
        <Reveal
          renderPose={revealed => (
            <ClientContainer
              initialPose="exit"
              pose={revealed ? "enter" : null}
              className={styles.wrapper}
            >
              <Client
                logo={tv4}
                url="https://www.tv4.se/"
                client="Tv4"
              />
              <Client
                logo={spotify}
                url="https://www.spotify.com/se/"
                client="Spotify"
              />
              <Client
                logo={hemnet}
                url="https://www.hemnet.se/"
                client="Hemnet"
              />
              <Client
                logo={netent}
                url="https://www.netent.com/"
                client="NetEnt"
              />
              <Client
                logo={bifirm}
                url="http://www.bifirm.com/sv/"
                client="Bi Firm"
              />
              <Client
                logo={spiderads}
                url="http://www.spiderads.eu/sv/"
                client="SpiderAds"
              />
              <Client
                logo={timecut}
                url="https://www.timecut.se/"
                client="Timecut"
              />
              <Client
                logo={krogsveen}
                url="https://www.krogsveen.no/"
                client="Krogsveen"
              />
              <Client
                logo={nti}
                url="https://www.ntigymnasiet.se/"
                client="NTI Gymnasiet"
              />
              <Client
                logo={avestaKommun}
                url="https://www.avesta.se/"
                client="Avesta kommun"
              />
            </ClientContainer>
          )}
        />
      </section>
    )
  }
}

export default Clients



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Clients/index.jsx